import * as types from "./actionTypes";

export const setClient = (client) => ({
  type: types.SET_CLIENT,
  payload: client
});
